import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Card, Table, Form, Row, Col, Button } from 'react-bootstrap'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import { Link, useNavigate } from 'react-router-dom'
import UpdateTransaction from './UpdateTransaction'
import { theme } from '../theme/theme'
import CustomBtn from '../common/CustomBtn'
import { BASE_URL } from '../constants'


const BookingTransactionList = () => {
  const [transactions, setTransactions] = useState([])
  const currentDate = new Date().toISOString().split('T')[0]
  const [selectedDate, setSelectedDate] = useState(currentDate) // Initialize with current date
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [txn, setTxn] = useState(false)
  // Get the auth token from cookies
  const token = Cookies.get('authToken')

  const [userType, setUserType] = useState()
  useEffect(() => {
    const role = Cookies.get('user_type')
    setUserType(role || 'EMPLOYEE')
  })
  // Fetch transactions based on selected date or default date
  const fetchTransactionsData = async (date = currentDate) => {
    setLoading(true)
    try {
      const response = await axios.get(BASE_URL+
        `/get/booking/transaction/date?date=${date}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Set the Authorization header for all requests
          },
        },
      )

      console.log(response.data.data)
      console.log('Checking for data: ', response.data.data)
      if (response.data.data && response.data.data.length === 0) {
        setTransactions([]) // No transactions for the date
      } else {
        setTransactions(response.data.data) // Set transactions data
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          'No transactions are available for the selected date',
      )
    } finally {
      setLoading(false)
    }
  }

  // Fetch transactions when component loads (for current date by default)
  useEffect(() => {
    fetchTransactionsData() // Fetch transactions for the current date initially
  }, [])
  const handleopn = (transaction) => {
    setTxn(transaction)
    console.log('transaction', transaction)
    setOpen(true)
  }
  // Handle date change event
  const handleDateChange = (event) => {
    const date = event.target.value
    setSelectedDate(date)
    fetchTransactionsData(date) // Fetch transactions for the selected date
  }
  // Function to format date for display
  const formatTransactionDateTime = (bookingDate) => {
    const date = new Date(bookingDate)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }
  const handleFetchData = () => {
    fetchTransactionsData()
  }

  const buttonStyle = {
    tranition: 'transform 0.3s ease',
  }
  const buttonHoverstyle = {
    transform: 'scale(1.2)',
  }
  const [isHovered, setIsHovered] = useState(false)
  return (
<Container className="pb-3" style={{fontFamily: theme.font.family }}>

      {!open && (
        <div className="pb-2 rounded-3">
          {/* <Card.Header className="text-success text-center bg-light">
            <h2 className="mb-2 fw-bold">Booking Transactions</h2>
          </Card.Header> */}

          <Container  >
            <Row className="justify-content-start p-2" style={{backgroundColor: theme.colors.background, padding:'10px'}}>
              <Col xs={12} md={6} lg={4}>
                <Form className="text-start">
                  <Form.Group className="mb-2">
              <Form.Label style={{ fontWeight: 'bold', color: theme.colors.primary }}>Select Transaction Date</Form.Label>

                    <Form.Control
                      type="date"
                      value={selectedDate}
                      onChange={handleDateChange} // Trigger API call when date is selected
                    />
                  </Form.Group>
                </Form>
              </Col>

              <Col className="text-start" style={{ marginTop: '2rem' }}>
              <CustomBtn 
                  onClick={handleFetchData}
              
              >
                Search
              </CustomBtn>
              </Col>
            </Row>
          </Container>

          {/* <Card.Body> */}
          <div className='px-3 mb-3 mt-3' style={{ backgroundColor: theme.colors.background }}>
          
            <Table
              bordered
              hover
              responsive="md"
              className="text-center  table table-striped table-bordered table-hover"
            >
              <thead className="text-start  position-sticky top-0">
                  <tr>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Transaction ID</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking ID</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Managed By</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Payment Method</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Transaction Amount</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Online Transaction Number</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Date & Time</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Action</th>
                  </tr>
                  
              </thead>
              <tbody className="text-start">
                {loading ? (
                  <tr>
                    <td colSpan={8} className="text-center">
                      Loading transactions...
                    </td>
                  </tr>
                ) : transactions.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center text-danger ">
                      No transactions available for the selected date
                    </td>
                  </tr>
                ) : (
                  transactions.map((transaction) => (
                    <tr key={transaction.id}>
                      <td>{transaction.id}</td>
                      {/* <td>{transaction.booking_id}</td> */}
                      <td style={{ cursor: 'pointer' }}>
                        <Link
                          to={`/BookedDetailpage/${transaction.booking_id}`}
                        >
                          {transaction.booking_id}
                        </Link>
                      </td>
                      <td>{transaction.transaction_managed_by}</td>
                      <td>{transaction.payment_method}</td>
                      <td>₹ {transaction.transaction_amount}</td>
                      <td>
                        {transaction.payment_method !== 'CASH'
                          ? transaction.online_transaction_number
                          : 'N/A'}
                      </td>{' '}
                      <td>
                        {formatTransactionDateTime(
                          transaction.transaction_date,
                        )}
                      </td>
                      <td>
                        <Link
                          to={`/bookingpayment/${transaction.id}`}
                          className="btn btn-outline-primary btn-sm me-4"
                          title="Print Transaction Receipt"
                          style={
                            isHovered === `print-${transaction.id}`
                              ? { ...buttonStyle, ...buttonHoverstyle }
                              : buttonStyle
                          }
                          onMouseEnter={() =>
                            setIsHovered(`print-${transaction.id}`)
                          }
                          onMouseLeave={() => setIsHovered(null)}
                        >
                          Print
                        </Link>
                        {userType === 'ADMIN' && (
                          <Button
                            onClick={() => handleopn(transaction)}
                            variant="outline-success"
                            className="btn btn-outline-success btn-sm me-4 m-1"
                            title="Update Transaction"
                            style={
                              isHovered === `update-${transaction.id}`
                                ? { ...buttonStyle, ...buttonHoverstyle }
                                : buttonStyle
                            }
                            onMouseEnter={() =>
                              setIsHovered(`update-${transaction.id}`)
                            }
                            onMouseLeave={() => setIsHovered(null)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            </div>
          {/* </Card.Body> */}
        </div>
      )}
      {open && <UpdateTransaction transaction={txn} setOpen={setOpen} />}
    </Container>
  )
}

export default BookingTransactionList
